import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useClientAuthStore, useUIStore } from '../stores';
import './Client.css';

function ClientLogin() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error } = useClientAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isLoading) {
      return; // Prevent multiple submissions
    }

    try {
      // Use Zustand client auth store for authentication
      await login({
        phone: phone.trim(),
        password: password
      });

      // If no error is thrown, login succeeded
      useUIStore.getState().showSuccessNotification('Login successful! Welcome to your client portal.');
      
      // Small delay to ensure Zustand state propagates to all subscribers
      setTimeout(() => {
        navigate('/client/dashboard', { replace: true });
      }, 100);
      
    } catch (error) {
      // Error is already handled by the store, but we can show a notification
      useUIStore.getState().showErrorNotification(error.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="client-login-container">
      <div className="client-login-card">
        <h2>Client Login</h2>
        <p className="client-login-subtitle">Seemanchal Decor Client Portal</p>
        <form onSubmit={handleSubmit} className="client-login-form">
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter phone number"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button 
            type="submit" 
            className="client-login-button"
            disabled={isLoading || !phone.trim() || !password}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="client-login-footer">
          <p>Don't have an account? <Link to="/client/signup">Sign up here</Link></p>
        </div>
        {isLoading && (
          <div className="client-login-loading">
            <p>Authenticating with server...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClientLogin;

